import type { FormConfig } from '../types';
import coverSheet from '../pages/disposal/coverSheet';
import siteDetails from '../pages/disposal/siteDetails';
import receiptForecasting from '../pages/disposal/receiptForecasting';
import receiptRecording from '../pages/disposal/receiptRecording';
import barriersAndComments from '../pages/disposal/barriersAndComments';

const formConfig: FormConfig = {
  live: false,
  id: 'disposal',
  formName: 'Office of Government Property Disposal Pipeline',
  title: 'Office of Government Property Disposal Pipeline',
  subTitle: 'Summary page',
  identifier: '{department}, {land-property-name}',
  showSections: true,
  requiredFlag: true,
  approval: 'optional',
  approvalAllowUnsubmit: true,
  sections: [
    {
      title: 'Overview',
      slug: 'overview',
      subsections: [
        {
          title: 'Before you start',
          slug: 'cover-sheet',
          pages: coverSheet,
        },
      ],
    },
    {
      title: 'Site Details',
      slug: 'site-details',
      subsections: [
        {
          title: 'Site details',
          slug: 'site-details',
          pages: siteDetails,
        },
      ],
    },
    {
      title: 'Receipt Forecasting',
      slug: 'receipt-forecasting',
      subsections: [
        {
          title: 'Receipt forecasting',
          slug: 'receipt-forecasting',
          pages: receiptForecasting,
        },
      ],
    },
    {
      title: 'Receipt Recording',
      slug: 'receipt-recording',
      subsections: [
        {
          title: 'Receipt recording',
          slug: 'receipt-recording',
          pages: receiptRecording,
        },
      ],
    },
    {
      title: 'Barriers And Comments',
      slug: 'barriers-and-comments',
      subsections: [
        {
          title: 'Barriers and comments',
          slug: 'barriers-and-comments',
          pages: barriersAndComments,
        },
      ],
    },
  ],
};

export default formConfig;
